import { useStaticContext } from '../../context/contexts/static';
import { shouldShow } from '../../utils/encourageAppDownload';

/**
 * returns whether the encourage app download step should be shown
 *
 * @returns {boolean}
 */
const useShouldEncourageAppDownload = () => {
    const { encourageAppDownloadEnabled } = useStaticContext();
    const { senderInfo = {} } = useStaticContext();

    return encourageAppDownloadEnabled && shouldShow(senderInfo);
};

export default useShouldEncourageAppDownload;
